import * as Yup from 'yup';
import { PersonalInfoFields } from '@/data/Types';
import {
    formFieldsInitialValues,
    formFieldsValidationSchema,
    requiredFieldsMissing,
    requiredFormFields,
} from '@/forms/fields/utils';

const validation = {
    name: Yup.string().required('Du må oppgi navn'),
    telephone: Yup.string()
        .required('Du må oppgi telefonnummer')
        .transform((st: string) => st.replace(/\s/g, ''))
        .matches(/^(\+47)?\d{8}$/, 'Telefonnummeret er ugyldig'),
    email: Yup.string().required('Du må oppgi e-postadresse').email('E-postadressen er ugyldig'),
    foedselsdatoEllerOrgnr: Yup.string().required('Du må oppgi fødselsdato eller organisasjonsnummer'),
    comment: Yup.string(),
};

export const personalInfoFields: PersonalInfoFields = {
    name: {
        validation: validation.name,
        initialValue: '',
        required: true,
    },
    telephone: {
        validation: validation.telephone,
        initialValue: '',
        required: true,
    },
    email: {
        validation: validation.email,
        initialValue: '',
        required: true,
    },
    foedselsdatoEllerOrgnr: {
        validation: validation.foedselsdatoEllerOrgnr,
        initialValue: '',
        required: true,
    },
    comment: {
        validation: validation.comment,
        initialValue: '',
        required: false,
    },
};

export const personalInfoInitialValues = () => formFieldsInitialValues(personalInfoFields);
export const personalInfoValidationSchema = () => formFieldsValidationSchema(personalInfoFields);
export const personalInfoRequiredFields = () => requiredFormFields(personalInfoFields);
export const personalInfoRequiredFieldsMissing = (errors: string[]) =>
    requiredFieldsMissing(personalInfoFields, errors);
